interface ConditionalDisplayProps {
  condition: boolean,
  trueDisplay: JSX.Element | null,
  falseDisplay: JSX.Element | null,
};

const ConditionalDisplay = ({ condition, trueDisplay = null, falseDisplay = null }: ConditionalDisplayProps) => {
  if (condition) {
    return (trueDisplay);
  } else {
    return (falseDisplay);
  }
};

export default ConditionalDisplay;